import { h } from 'preact'
import { PureComponent } from 'preact-compat'

import { FederatedHit } from '../algolia/components'
import FederatedResults from './FederatedResults'

interface Props {
  hits: FederatedHit[]
  pageCount: number
  clickCallback: (hit: FederatedHit, idx: number) => void
}

interface State {
  hits: FederatedHit[]
}

export default class extends PureComponent<Props, State> {
  constructor () {
    super()
    this.state = {
      hits: []
    }
  }

  updateList () {
    let joinWith: State['hits'] = []
    if (this.props.pageCount > 0) {
      joinWith = this.state.hits
    }

    this.setState({
      hits: joinWith.concat(this.props.hits)
    })
  }

  componentDidMount () {
    this.updateList()
  }

  componentDidUpdate (prevProps: Props) {
    if (JSON.stringify(this.props.hits) === JSON.stringify(prevProps.hits)) return

    this.updateList()
  }

  render () {
    return (
      <div> {
        this.state.hits.map((hit, idx) => {
          return <FederatedResults key={hit.objectID} clickCallback={() => this.props.clickCallback(hit, idx)} hit={hit} />
        })
      }</div>
    )
  }
}
